import {Pipe, PipeTransform} from "@angular/core";
import {
    WaTemplateAction, WaTemplateIndex,
    WaTemplateTemplateContentButtons
} from "../../../modules/flow/template/wa-template-preview/wa-template.service";

export enum TemplateContentButtonType {
    DIAL = "dial",
    WEB_SITE_URL = "websiteUrl",
    QUICK_REPLY = "quickReply",
    COPY_CODE = "copyCode",
    CATALOG = "catalog"
}

export interface TemplateButtons {
    type: TemplateContentButtonType,
    content: any,
    index: number,
}


@Pipe({
    name: 'waTemplateButtonPipe',
})
export class TemplateContentButtonPipe implements PipeTransform {
    transform(waTemplateButtons: WaTemplateTemplateContentButtons): TemplateButtons[] {
        const buttonsFilter: TemplateButtons[] = [];
        if(waTemplateButtons.action) {
            let action: WaTemplateAction = waTemplateButtons.action;
            if(action.dial) {
                for (let dial of action.dial) {
                    buttonsFilter.push({
                        type: TemplateContentButtonType.DIAL,
                        content: dial,
                        index: dial.index
                    })
                }

            }

            if (action.websiteUrl || action.websiteUrls) {
                let websiteUrlValues = action.websiteUrls ? action.websiteUrls: action.websiteUrl
                for (let websiteUrl of websiteUrlValues) {
                    buttonsFilter.push({
                        type: TemplateContentButtonType.WEB_SITE_URL,
                        content: websiteUrl,
                        index: websiteUrl.index
                    })
                }
            }
        }

        if (waTemplateButtons.quickReply) {
            let quickReply: WaTemplateIndex[] = waTemplateButtons.quickReply;
            for (let quickReplyButton of quickReply) {
                buttonsFilter.push({
                    type: TemplateContentButtonType.QUICK_REPLY,
                    content: quickReplyButton,
                    index: quickReplyButton.index
                })
            }
        }

        if (waTemplateButtons.copyCode) {
            buttonsFilter.push({
                type: TemplateContentButtonType.COPY_CODE,
                content: waTemplateButtons.copyCode,
                index: waTemplateButtons.copyCode.index
            })
        }

        if (waTemplateButtons.catalog) {
            buttonsFilter.push({
                type: TemplateContentButtonType.CATALOG,
                content: waTemplateButtons.copyCode,
                index: waTemplateButtons.copyCode.index
            })
        }

        return buttonsFilter.sort(sortBy);
    }
}

function sortBy(x: TemplateButtons, y: TemplateButtons): number {
    if (x.index < y.index) {
        return -1;
    }
    if (x.index > y.index) {
        return 1;
    }
    return 0;
}